import _ from 'lodash';

import { core, toJSONArray } from '@tock/coretypes';
import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';

export type WaitlistWrapper = core.Waitlist | dashboard.WaitlistReportRow;

interface State {
  requestInProgress: boolean;
  isInitialized: boolean;
  waitlistEntriesExact: WaitlistWrapper[];
  waitlistEntriesPartial?: WaitlistWrapper[];
}

const initialState: State = {
  requestInProgress: false,
  isInitialized: false,
  waitlistEntriesExact: [],
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.WAITLIST_FETCH_FOR_TICKET_GROUP_STARTING: {
      return {
        ...state,
        requestInProgress: true,
        isInitialized: false,
      };
    }
    case AppConstants.WAITLIST_FETCH_FOR_TICKET_GROUP_DONE: {
      if (_.isArray(payload) && !_.isEmpty(payload) && payload[0].matchPartial) {
        return {
          requestInProgress: false,
          isInitialized: true,
          waitlistEntriesExact: cleanWaitlistEntries(payload[0].matchExact),
          waitlistEntriesPartial: cleanWaitlistEntries(payload[0].matchPartial),
        };
      } else {
        return {
          requestInProgress: false,
          isInitialized: true,
          waitlistEntriesExact: cleanWaitlistEntries(payload),
        };
      }
    }
    case AppConstants.WAITLIST_FETCH_FOR_TICKET_GROUP_FAILED: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    default:
      return state;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function cleanWaitlistEntries(payload: any): WaitlistWrapper[] {
  return _.uniqBy(toJSONArray<WaitlistWrapper>(payload), (waitlistEntry) => {
    return (waitlistEntry.patron as core.Patron).id;
  });
}
